import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faDatabase, faFolderTree, faBuildingColumns, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';

const Disclaimer = () => {
    return (
        <>
            <section id="disclaimer" className="py-2">
                <div className="container-fluid ps-0 pe-0">
                    <div className="row">
                        <div className="col-12">
                            <div className="card-group shadow">
                                <div className="card bg-transparent">
                                    <div className="card-body text-center p-3">
                                        <FontAwesomeIcon size="3x" className="bi bi-2-circle text-primary mb-4" icon={faFolderTree} />
                                        <h6 className="fw-bold text-uppercase_ mb-4">¿Qué tipo de información encuentro aquí?</h6>
                                        <p className="mb-4 text-secondary texto-justificado">Aquí se puede encontrar información biológica y pesquera de los recursos de interés comercial en la industria pesquera artesanal e industrial.</p>
                                    </div>
                                </div>
                                <div className="card bg-transparent">
                                    <div className="card-body text-center p-3">
                                        <FontAwesomeIcon size="3x" className="bi bi-2-circle text-primary mb-4" icon={faDatabase} />
                                        <h6 className="fw-bold text-uppercase_ mb-4">¿Cuál es la fuente de esta información?</h6>
                                        <p className="mb-4 text-secondary texto-justificado">Los datos que puedes encontrar aquí, son recopilados por IFOP y representan el resultado de la ejecución de más de un centenar de proyectos que se desarrollan todos los años.</p>
                                    </div>
                                </div>
                                <div className="card bg-transparent">
                                    <div className="card-body text-center p-3">
                                        <FontAwesomeIcon size="3x" className="bi bi-2-circle text-primary mb-4" icon={faClipboardCheck} />
                                        <h6 className="fw-bold text-uppercase_ mb-4">¿Cómo se obtienen estos datos?</h6>
                                        <p className="mb-4 text-secondary texto-justificado">Los datos que encontraras aquí, son el resultado de un proceso de recopilación de datos que cuenta con una etapa de requerimientos, planificación, recopilación, almacenamiento, validación y liberación del dato. </p>

                                    </div>
                                </div>
                                <div className="card bg-transparent">
                                    <div className="card-body text-center p-3">
                                        <FontAwesomeIcon size="3x" className="bi bi-2-circle text-primary mb-4" icon={faBuildingColumns} />
                                        <h6 className="fw-bold text-uppercase_ mb-4">¿A quién va dirigida esta información?</h6>
                                        <p className="mb-4 text-secondary texto-justificado">Al público general, académico, científico, a organizaciones gubernamentales y no gubernamentales y al estado de Chile</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Disclaimer;
